import type { RouteConfig } from 'vue-router'
import { ROUTE_NAMES } from './routeNames.const'

export const routeCustomerQualification: RouteConfig = {
  path: '/customer-qualification/',
  name: ROUTE_NAMES.customerQualification.base,
  component: () =>
    import(
      /* webpackChunkName: "CustomerQualification" */ 'src/pages/CustomerQualification/CustomerQualification.vue'
    ),
  meta: {
    prevRoute: ROUTE_NAMES.synthesis,
    nextRoute: (parameters?: { mustUpdateQualification: boolean }) =>
      parameters?.mustUpdateQualification
        ? ROUTE_NAMES.customerQualification.survey
        : ROUTE_NAMES.customerQualification.summary,
  },
  children: [
    {
      path: 'survey',
      name: ROUTE_NAMES.customerQualification.survey,
      component: () =>
        import(
          /* webpackChunkName: "CustomerQualification" */ 'src/pages/CustomerQualification/Survey/CustomerSurvey.vue'
        ),
      meta: {
        nextRoute: ROUTE_NAMES.customerQualification.summary,
        prevRoute: ROUTE_NAMES.synthesis,
      },
    },
    {
      path: 'summary',
      name: ROUTE_NAMES.customerQualification.summary,
      component: () =>
        import(
          /* webpackChunkName: "CustomerQualification" */ 'src/pages/CustomerQualification/CurrentSituation/CustomerCurrentSituation.vue'
        ),
      meta: {
        prevRoute: (parameters?: { allowRiskProfile: boolean }) =>
          parameters?.allowRiskProfile
            ? ROUTE_NAMES.customerQualification.survey
            : ROUTE_NAMES.synthesis,
        nextRoute: ROUTE_NAMES.reallocation,
      },
    },
  ],
}
